import { createSlice } from "@reduxjs/toolkit";

interface SnackbarState {
	autoHideDuration: number | string | undefined;
	isOpen: boolean;
	transition: string;
	severity: string | undefined;
	vertical: string;
	horizontal: string;
	message: string;
}

const initialState: SnackbarState = {
	autoHideDuration: process.env.MESSAGE_AUTO_HIDE_DURATION,
	isOpen: false,
	transition: "",
	severity: "info",
	vertical: "bottom",
	horizontal: "left",
	message: "",
};

export const mainSlice = createSlice({
	name: "main",
	initialState: {
		snackbar: initialState,
		fullLoading: false,
		admin: null,
	},
	reducers: {
		handleSnackbarOpen: (state, action) => {
			state.snackbar = {
				...state.snackbar,
				isOpen: true,
				severity: action.payload.severity || "info",
				message: action.payload.message || "",
			};
		},
		handleSnackbarClose: (state) => {
			state.snackbar = {
				...state.snackbar,
				isOpen: false,
				message: "",
			};
		},
		setFullLoading: (state, action) => {
			state.fullLoading = action.payload;
		},
		setAdmin: (state, action) => {
			state.admin = action.payload;
		},
	},
});

export const { handleSnackbarOpen, handleSnackbarClose, setFullLoading, setAdmin } =
	mainSlice.actions;
export default mainSlice.reducer;
